var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgEft = function SvgEft(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 18 19",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "eft")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.4.1-Wallet-Top-Up",
    transform: "translate(-35.000000, -499.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eft",
    transform: "translate(32.000000, 496.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.94453,4.03698001 L4.27480754,9.1501283 C4.22885468,9.18076355 4.21643729,9.24285048 4.24707253,9.28880335 C4.26561911,9.31662322 4.29684224,9.33333333 4.33027756,9.33333333 L19.6697224,9.33333333 C19.7249509,9.33333333 19.7697224,9.28856181 19.7697224,9.23333333 C19.7697224,9.19989801 19.7530123,9.16867488 19.7251925,9.1501283 L12.05547,4.03698001 C12.0218801,4.01458672 11.9781199,4.01458672 11.94453,4.03698001 Z M6.48888889,9.61614803 L6.48888889,16.9286961 M9.77777778,16.9286961 L9.77777778,9.61614803 M13.4222222,9.61614803 L13.4222222,16.9286961 M16.7111111,16.9286961 L16.7111111,9.61614803 M4,17.716148 L4,19.916148 C4,19.9713765 4.04477153,20.016148 4.1,20.016148 L19.9,20.016148 C19.9552285,20.016148 20,19.9713765 20,19.916148 L20,17.716148 C20,17.6609196 19.9552285,17.616148 19.9,17.616148 L4.1,17.616148 C4.04477153,17.616148 4,17.6609196 4,17.716148 Z",
    id: "Shape",
    stroke: "#000000de",
    strokeWidth: 2,
    fillRule: "nonzero"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eft.e9c7ec73.svg";
export { ForwardRef as ReactComponent };